var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66665 12.0007C7.84996 12.0004 8.99918 11.6043 9.93131 10.8753L12.862 13.806L13.8046 12.8633L10.874 9.93265C11.6033 9.00043 11.9997 7.85094 12 6.66732C12 3.72665 9.60731 1.33398 6.66665 1.33398C3.72598 1.33398 1.33331 3.72665 1.33331 6.66732C1.33331 9.60798 3.72598 12.0007 6.66665 12.0007ZM6.66665 2.66732C8.87265 2.66732 10.6666 4.46132 10.6666 6.66732C10.6666 8.87332 8.87265 10.6673 6.66665 10.6673C4.46065 10.6673 2.66665 8.87332 2.66665 6.66732C2.66665 4.46132 4.46065 2.66732 6.66665 2.66732Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.f523a6c7817f97702dfc51d083adbd78.svg";
export { ForwardRef as ReactComponent };